import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { ConfigService } from './config.service';
import { AdvisoryType } from './models/app-config';

@Injectable({ providedIn: 'root' })
export class ProfileService {
  private readonly http = inject(HttpClient);
  private readonly config = inject(ConfigService);
  private data: Record<string, string> = {};

  async load(): Promise<void> {
    this.data = await lastValueFrom(
      this.http.get<Record<string, string>>(`${this.config.apiBase}/profile`)
    );
  }

  get(key: string): string {
    return this.data[key] ?? '';
  }

  get environment(): string {
    return this.data['environment'] ?? '';
  }

  get isProd(): boolean {
    const env = this.environment.toLowerCase();
    return env === 'prod' || env === 'production';
  }

  get showAdvisories(): AdvisoryType[] {
    const raw = this.data['show_advisories'] ?? 'wq,cso';
    return raw.split(',')
      .map(s => s.trim().toLowerCase())
      .filter((s): s is AdvisoryType => s === 'wq' || s === 'cso');
  }
}
